export default __webpack_public_path__ + "static/media/twitter.10c93d0c.webp";